module.exports = __webpack_public_path__ + "static/network-b941333109e976b3882ba7117a091ea8.mp4";